import type { SearchCacheBackend } from "@pdfking/compatibility"
import { RecordCreate } from "@pdfking/tfunc"

export const MemoryCache = <V>(): SearchCacheBackend<V> => {
  const cache = new Map<string, V>()

  return {
    clear: async () => cache.clear(),
    delete: async (key: string) => void cache.delete(key),
    exists: async (key: string) => cache.has(key),
    get: async (key: string) => cache.get(key),
    set: async (key: string, value: V) => void cache.set(key, value),
    startswith: async (prefix?: string) =>
      RecordCreate(
        prefix
          ? [...cache.entries()].filter(([key]) => key.startsWith(prefix))
          : cache.entries()
      ),
  }
}
